import type { ChangeEvent } from "react";
import type { InputOnChangeData } from "../../../components/Input/Input";
import type { Measures } from "../../../types/entities";
import { normalizeTypeTags } from "../../../utils/typeTags";
import type { AddProductFormState } from "./form-state";

export interface AddProductInteractionState extends AddProductFormState {
  error: string | null;
}

function resolveInputValue(
  event: ChangeEvent<HTMLInputElement>,
  data: InputOnChangeData,
): string {
  return data.value || event.target.value;
}

export function setNameValue(
  state: AddProductInteractionState,
  event: ChangeEvent<HTMLInputElement>,
  data: InputOnChangeData,
): void {
  state.name = resolveInputValue(event, data);
  state.error = null;
}

export function setDescriptionValue(
  state: AddProductInteractionState,
  event: ChangeEvent<HTMLInputElement>,
  data: InputOnChangeData,
): void {
  state.description = resolveInputValue(event, data);
  state.error = null;
}

export function setPhotoValue(
  state: AddProductInteractionState,
  event: ChangeEvent<HTMLInputElement>,
  data: InputOnChangeData,
): void {
  state.photo = resolveInputValue(event, data);
  state.error = null;
}

export function setParentIdValue(
  state: AddProductInteractionState,
  event: ChangeEvent<HTMLInputElement>,
  data: InputOnChangeData,
): void {
  state.parentId = resolveInputValue(event, data);
  state.error = null;
}

export function setQuantityValue(
  state: AddProductInteractionState,
  event: ChangeEvent<HTMLInputElement>,
  data: InputOnChangeData,
): void {
  state.quantityInput = resolveInputValue(event, data);
  state.error = null;
}

export function setTypeTagInputValue(
  state: AddProductInteractionState,
  value: string,
): void {
  state.typeTagInput = value;
  state.error = null;
}

export function addTypeTagsValue(
  state: AddProductInteractionState,
  tags: string[],
): void {
  state.typeTags = normalizeTypeTags([...state.typeTags, ...tags]);
  state.error = null;
}

export function removeTypeTagValue(
  state: AddProductInteractionState,
  tag: string,
): void {
  state.typeTags = state.typeTags.filter((item) => item !== tag);
  state.error = null;
}

export function setManufacturingDateInputValue(
  state: AddProductInteractionState,
  value: string,
): void {
  state.manufacturingDate = value;
  state.error = null;
}

export function setExpiryDateInputValue(
  state: AddProductInteractionState,
  value: string,
): void {
  state.expiryDate = value;
  state.error = null;
}

export function setMeasureValue(
  state: AddProductInteractionState,
  measure: Measures,
): void {
  state.measure = measure;
}
